import React from 'react';
import PropTypes from 'prop-types';
import {get} from './Storage';
import axios from 'axios';
import { MGSiteButton } from "mgUiKit";
import LinearProgress from 'material-ui/LinearProgress';
import {ClassName} from 'mgToolsKit';
import css from './less/keepalive.module.less';
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'MGKeepAliveComponent';

class KeepAlive extends React.Component {
    constructor(props) {
        super(props);
        
        var countDownExpire = 0;
        var disableAutoRenew = true;
        if(props.checkSession){            
            countDownExpire =  props.sessionInfo.sessionExpire + props.sessionInfo.maxClockSkew;
            disableAutoRenew = AppSettings.disableautorenew || (!AppSettings.disableautorenew && !props.sessionInfo.sessionAutoRenew);
            //countDownExpire = 5000;
        }

        this.state = {
            expired: false, // Flag sessione scaduta
            completed: 2, // [0-100] completamento progressbar rinnovo manuale
            enableRenew: false, // Attiva il rinnovo manuale
            loading: false, // loading rinnovo manuale
            countDownExpire: countDownExpire, // session expire
            renewSuccess: false, // flag rinnovo avvenuto con successo

            enableRenderLogin: false,
            enableRenderRenew: false,
            startAutoRenew:false, // Innesco autorinnovo

        }
        
        // Interval utilizzata per la verifica della sessione
        this.intervalKeepAlive = null;
        
        // autorenew
        this.timerProgressBar = null;
        this.stepProgressBar = 1;
        this.renewAction = this.renewAction.bind(this);
        this.autoRenewCount = 0;
        this.getSessionExpireNumbersTries = 3;
        this.getSessionExpireTry = 0;
        this.disableAutoRenew = disableAutoRenew;
        this.timeRetryGetSessionExpire = 10000;

        // Login
        this.loginAction = this.loginAction.bind(this);
        this.reloadPage = this.reloadPage.bind(this);
    }

    componentDidMount() {     
        
    }

    componentWillMount() {
        if(this.props.checkSession){
            clearInterval(this.intervalKeepAlive);
            this.checkSession();
        }
    }

    reloadPage(event){
        location.reload();
    }

    // Progress della barra per il rinnovo manuale
    progress() {
        var completed = this.state.completed;
        if (completed > 100) {
            clearInterval(this.timerProgressBar);
            this.setState({
                completed: 100,
                enableRenew: false,
                startAutoRenew: false
            });

        } else {
            completed = completed + this.stepProgressBar;
            this.setState({completed});
        }
    }

    // Check per la verifica della scadenza della sessione
    checkSession(){
        if(this.intervalKeepAlive != null){
            clearTimeout(this.intervalKeepAlive);
        }
        
        this.intervalKeepAlive = setTimeout(function(){
            clearInterval(this.timerProgressBar);
            /*
            this.setState({
                startAutoRenew:false
            });*/
            
            // Rinnovo automatico
            if(!this.disableAutoRenew){
                 // il rinnovo automatico sarà fatto {this.props.sessionInfo.autoRenewTimes} volte
                 if(this.autoRenewCount <= parseInt(this.props.sessionInfo.autoRenewTimes)) {
                    this.autoRenewCount = this.autoRenewCount + 1;
                    this.setState({
                       startAutoRenew:true
                    });
                    // Verifica se la sessione si è aggiornata
                    this.getSessionExpiration();
                }
                else{
                    this.setState({
                        expired: true,
                        enableRenew: false // abilito il bottone login
                    });
                }
            }
            else{  
                // Attivo la progress bar per il rinnovo manuale             
                this.timerProgressBar = setInterval(() => this.progress(), 100);
                this.setState({
                    completed: 0,
                    expired: true,
                    loading:false,
                    enableRenew: true
                });                
            }

        }.bind(this),this.state.countDownExpire);
    }   

    getSessionExpiration(){
        var url = AppSettings['env'].urlUserBoxGetSessionExpiration;
        axios.post(url)
            .then(({dataInput, status, statusText}) => {
                 var data = parseInt(dataInput);
                 // se la sessione non è scaduta
                 if(data > 0){
                    clearInterval(this.intervalKeepAlive);
                    this.getSessionExpireTry = 0;
                    this.setState({
                        countDownExpire: data,
                        expired: false,
                        //renewSuccess:true,
                        startAutoRenew: false // Nascondo iframe auto rinnovo
                    });
                    this.checkSession();
                }
                else{
                   // Riprovo per {this.getSessionExpireNumbersTries}
                   this.retryGetSessionExpiration();  
                }                
            })
            .catch((error) => {
                // Riprovo per {this.getSessionExpireNumbersTries}
                this.retryGetSessionExpiration();    
        });
    }

    retryGetSessionExpiration(){
        setTimeout(()=>{
            if(this.getSessionExpireTry < this.getSessionExpireNumbersTries){
                this.getSessionExpireTry = this.getSessionExpireTry + 1;
                this.getSessionExpiration()
            }
            else{
                this.setState({
                    enableRenew: false, // Attivo il bottone login
                    expired: true,
                    startAutoRenew: false
                });
            }
        },this.timeRetryGetSessionExpire);
    }

    // Actions
    renewAction(event){
        this.loginAction();
    }

    popupLoginClosed(){        
        this.getSessionExpiration();
    }

    loginAction(event){
        this.autoRenewCount = 0;
        var loginPopup = window.open(this.props.sessionInfo.urlLogin, "", "width=550, height=450, top=200, left=300,toolbar=no,scrollbars=yes");
        this.setState({
            expired: false
        });
        this.getSessionExpireTry = 0;
        clearInterval(popupTick);
        var popupTick = setInterval(function() {
            if (loginPopup.closed) {
                clearInterval(popupTick);
                this.popupLoginClosed();
            }
        }.bind(this), 500);        
    }

    renderRenewProgressBar(){
        var classNameArray = ['fa', 'fa-refresh'];
        var message = "La sessione sta per scadere, clicca per rinnovarla";
        if(this.state.loading ){
            classNameArray.push('fa-spin');
            message = "Aggiornamento in corso...";

        }
        return (
            <div className={css['mg-keepalive']}>
                    {!this.state.loading ? 
                        <LinearProgress mode="determinate" value={this.state.completed}  color="#ff6f00" />
                        
                    : null }
                    <p>{message}&nbsp;&nbsp;&nbsp;</p>
                    
                    <MGSiteButton                     
                        disabled={false}
                        primary={true}
                        isButton={true}
                        fullWidth={false}
                        iconBefore={ClassName(classNameArray)}
                        actionFunc={this.renewAction}
                    />                  
            </div>
        )
    }

    renderLogin(){
        return (
            <div className={css['mg-keepalive']}>
                <p>La sessione è scaduta, clicca per autenticarti&nbsp;&nbsp;&nbsp;</p>
                <MGSiteButton                     
                    disabled={false}
                    primary={true}
                    isButton={true}
                    fullWidth={false}
                    iconBefore="fa fa-user"
                    actionFunc={this.loginAction}
                />               
            </div>
        )
    }

    renderKeepAlive(){
        var render="";
        var progressBar="";
        if(this.props.checkSession){
            // Sessione scaduta
            if(this.state.expired){
                // Progress bar rinnovo manuale
                if(this.state.enableRenew){
                    progressBar = this.renderRenewProgressBar();  
                }
                else{
                    // Botton per il login
                    progressBar = this.renderLogin();
                }
            }

            // AutoRenew
            if(this.state.startAutoRenew){
                render = <iframe style={{display: "none"}} src={this.props.sessionInfo.urlLogin} width="550" height="450"></iframe>
                
            }         
        }
        else{
            render = <div className="mg-keep-alive">
                    Sessione scaduta: <a href="#" onClick={this.reloadPage}>clicca qui per aggiornare la pagina</a>
                </div>;
        }
        
        return (

            <div id="keepAliveContainer">
                {progressBar}
                {render}
            </div>
        )
    }

    render() {
        return this.renderKeepAlive()
    }
}

KeepAlive.displayName = componentName;

// PropTypes validation
KeepAlive.propTypes = {
    sessionInfo: PropTypes.object,
    checkSession: PropTypes.bool
};
// default props
KeepAlive.defaultProps = {
    checkSession: false,
    sessionInfo: null
};
export default  KeepAlive;